import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Link } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Link>>>;

const getLinksForForm = (id: string): ReturnType => {
    return Request.get(`/links/form/${id}`);
};

export default getLinksForForm;
